import React from 'react';
import { company, contact } from '../../content/site';
import { ArrowRight, Mail, MapPin, Phone, socialIcons } from '../Common/Icons';

const telHref = (phone) => `tel:${phone.replace(/[^+\d]/g, '')}`;

const Contact = () => (
  <section className="section section--dark" id="contact">
    <div className="container">
      <div className="contact__grid">
        <div>
          <p className="eyebrow">Contact</p>
          <h2>Let’s talk about your project.</h2>
          <p className="section-head__lead">{company.tagline}</p>

          <div style={{ marginTop: 'var(--s-7)' }}>
            <a href={`mailto:${contact.email}`} className="btn">
              Request a Quote
              <ArrowRight />
            </a>
          </div>

          <ul className="contact__socials">
            {contact.socials.map((social) => {
              const Icon = socialIcons[social.icon];
              return (
                <li key={social.label}>
                  <a
                    href={social.href}
                    className="social-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.label}
                  >
                    <Icon />
                  </a>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="contact__cards reveal">
          <a
            className="contact-card contact-card--wide"
            href={contact.mapUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="contact-card__label">
              <MapPin />
              Office
            </span>
            <span className="contact-card__value">{contact.address}</span>
            <span className="contact-card__note">Open in Google Maps</span>
          </a>

          <a className="contact-card" href={`mailto:${contact.email}`}>
            <span className="contact-card__label">
              <Mail />
              Email
            </span>
            <span className="contact-card__value contact-card__value--email">{contact.email}</span>
          </a>

          <div className="contact-card">
            <span className="contact-card__label">
              <Phone />
              Telephone
            </span>
            <span className="contact-card__value contact-card__value--stack">
              {contact.phones.map((phone) => (
                <a key={phone} href={telHref(phone)}>
                  {phone}
                </a>
              ))}
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Contact;
